<template>
  <SmallSquare content="可设置门店核销订单的奖励" :padding='true' />
  <a-card :bordered="false">
    <a-form ref="ruleForm" :model="form" :rules="rules" >
      <a-form-item label="" name='' :wrapper-col="{ span: 18,offset:1}" style='margin-bottom: 10px;'>
        <div class="s_flex_ali">
          <a-checkbox v-model:checked="form.is_order_write" @change="()=>{form.is_order_write?form.is_order_write=1:form.is_order_write=0}"></a-checkbox>
          <p class="m-r-10 m-l-10" style="width:240px">门店核销订单抵扣积分，满</p>
          <a-input-number v-model:value="form.order_write" class='m-r-10' style="width:20%;" :max="10000" :min="0" :precision='0' :disabled="!form.is_order_write" />
          积分奖励1积分
        </div>
      </a-form-item>
      <a-form-item label="" name='' :wrapper-col="{ span: 18,offset:1}" style='margin-bottom: 10px;'>
        <div class="s_flex_ali">
          <a-checkbox v-model:checked="form.is_user_write" @change="()=>{form.is_user_write?form.is_user_write=1:form.is_user_write=0}"></a-checkbox>
          <p class="m-r-10 m-l-10" style="width:240px">门店线下核销消费者积分，满</p>
          <a-input-number v-model:value="form.user_write" class='m-r-10' style="width:20%;" :max="10000" :min="0" :precision='0' :disabled="!form.is_user_write" />
          积分奖励1积分
        </div>
      </a-form-item>
      <a-form-item label="" name='' :wrapper-col="{ span: 18,offset:1}" style='margin-bottom: 10px;'>
        <div class="s_flex_ali">
          <a-checkbox v-model:checked="form.is_activity_gift" @change="()=>{form.is_activity_gift?form.is_activity_gift=1:form.is_activity_gift=0}"></a-checkbox>
          <p class="m-r-10 m-l-10" style="width:240px">门店核销订单中使用的优惠券，每核销</p>
          <a-input-number v-model:value="form.activity_gift" class='m-r-10' style="width:20%;" :max="10000" :min="0" :precision='0' :disabled="!form.is_activity_gift" />
          张优惠券奖励1积分
        </div>
      </a-form-item>
      <a-form-item label="" name='' :wrapper-col="{ span: 18,offset:1}" style='margin-bottom: 10px;'>
        <div class="s_flex_ali">
          <a-checkbox v-model:checked="form.is_order_coupon" @change="()=>{form.is_order_coupon?form.is_order_coupon=1:form.is_order_coupon=0}"></a-checkbox>
          <p class="m-r-10 m-l-10" style="width:240px">门店核销活动礼品，每核销</p>
          <a-input-number v-model:value="form.order_coupon" class='m-r-10' style="width:20%;" :max="10000" :min="0" :precision='0' :disabled="!form.is_order_coupon" />
          个礼品奖励1积分
        </div>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 4,offset:1}" class='m-t-25'>
        <a-button type="primary" v-has:writeOffSet="onSubmit">
          保存设置
        </a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>
<script>
import { ref, onMounted } from 'vue';
import { setWrite, getWrite } from '@/api/reimbursement';
import { iscode } from '@/utils/app';
import { message } from 'ant-design-vue';
// 初始化默认筛选项数值
let defForm = {
  is_order_write: 0,
  order_write: 100,
  is_user_write:0,
  user_write:100,
  is_activity_gift:0,
  activity_gift:10,
  is_order_coupon:0,
  order_coupon:10
}
export default {
  setup() {
    const form = ref({ ...defForm });
    const ruleForm = ref()
    const onSubmit = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res = await setWrite( form.value ).then((res) => res.data).catch(error=>error);
      if (iscode(res)) {
        message.success(res.msg);
        initData();
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    };
    const initData = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res = await getWrite().then((res) => res.data).catch(error=>error);
      if (iscode(res)) {
        form.value = res.data;
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    };
    onMounted(() => {
      initData();
    });
    return {
      form,
      ruleForm,
      onSubmit,
    };
  },
};
</script>
